import { Directive, forwardRef, Provider } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[validateUserName][ngModel],[validateUserName][formControl]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => UserNameValidator), multi: true }
  ]
})
export class UserNameValidator {

  validate(control: AbstractControl): { [validator: string]: string } {
    if (!control.value) { // the [required] validator will check presence, not us
      return null;
    }
    const value = control.value.trim();
    if (/^([a-zA-Z0-9_\.\-])+$/.test(value)  || /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value)) {
      return null;
    }
    return { validateEmail: 'GLOBAL.PLEASE_ENTER_A_VALID_USER_NAME' };
  }
}